import { createLocale } from "./createLocale";

export const ro = createLocale({
  header: {
    title: "Mergi global. 2 $ per Short. Orice limbă!",
    subtitle: "🔥Plătești doar pentru rezultat – de la $0.089 la $0.009 pe secundă🔥",
  },
  steps: {
    uploadVideo: "Încarcă video",
    selectLanguages: "Selectează limbile",
    conversionResult: "Conversie și rezultat",
  },
  upload: {
    dragAndDrop: "Trageți și plasați fișierul video aici",
    orClickToSelect: "sau faceți clic pentru a selecta",
    supportedFormats: "Formate acceptate: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Dimensiune maximă fișier: 200 MB",
    maxDuration: "• Durată maximă: 30 sec",
    chooseFile: "Alege fișier",
    selectedFile: "Fișier selectat:",
    size: "Dimensiune:",
    fileTypeError: "Vă rugăm să selectați un fișier video",
    fileSizeError: "Dimensiunea fișierului ({size} MB) depășește limita maximă de 200 MB",
    durationError: "Durata videoclipului ({duration} sec) depășește limita maximă de 30 sec",
    fileReadError: "Fișierul video nu poate fi citit. Încercați alt fișier.",
  },
  languages: {
    sourceAudioLanguage: "Limba audio sursă",
    targetAudioLanguage: "Limba audio țintă",
    selectLanguage: "Selectează limba...",
  },
  conversion: {
    replaceAudio: "Clonează-mi vocea",
    uploadVideoAndSelectLanguages: "Încarcă un videoclip și selectează limbile pentru a continua",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Politica de confidențialitate",
    termsOfUse: "Termeni de utilizare",
  },
  languageOptions: {
    ro: "Română",
  },
});
